var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLokiIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "128px",
    height: "128px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.801
    },
    fill: "#f2672a",
    d: "M 24.5,-0.5 C 25.5,-0.5 26.5,-0.5 27.5,-0.5C 27.9926,1.80562 28.3259,4.13895 28.5,6.5C 26.8333,6.5 25.1667,6.5 23.5,6.5C 22.1024,3.99301 22.4357,1.65968 24.5,-0.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.794
    },
    fill: "#f2672a",
    d: "M 19.5,12.5 C 17.5648,13.1495 15.5648,13.4828 13.5,13.5C 11.0003,8.16297 12.667,5.82964 18.5,6.5C 18.3253,8.6208 18.6586,10.6208 19.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#f26d29",
    d: "M 23.5,6.5 C 25.1667,6.5 26.8333,6.5 28.5,6.5C 28.2627,7.79105 28.596,8.79105 29.5,9.5C 29.5,10.5 29.5,11.5 29.5,12.5C 27.9582,13.3007 26.2915,13.634 24.5,13.5C 23.5318,11.3926 23.1984,9.0593 23.5,6.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.783
    },
    fill: "#f2672a",
    d: "M 35.5,13.5 C 33.8333,13.5 32.1667,13.5 30.5,13.5C 30.5,12.8333 30.1667,12.5 29.5,12.5C 29.5,11.5 29.5,10.5 29.5,9.5C 30.4737,7.91473 31.9737,6.91473 34,6.5C 34.977,8.73999 35.477,11.0733 35.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.783
    },
    fill: "#f2672a",
    d: "M 52.5,16.5 C 50.8828,17.038 49.2161,17.3713 47.5,17.5C 46.596,18.209 46.2627,19.209 46.5,20.5C 44.7085,20.366 43.0418,20.6993 41.5,21.5C 41.1667,19.5 40.8333,17.5 40.5,15.5C 42.5,15.1667 44.5,14.8333 46.5,14.5C 46.5,13.5 46.5,12.5 46.5,11.5C 50.5123,10.8874 52.5123,12.5541 52.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#f26d29",
    d: "M 19.5,12.5 C 19.5,14.5 19.5,16.5 19.5,18.5C 18.0813,19.4511 16.4147,19.7845 14.5,19.5C 14.5,18.8333 14.5,18.1667 14.5,17.5C 14.6716,16.5084 14.3382,15.8417 13.5,15.5C 13.5,14.8333 13.5,14.1667 13.5,13.5C 15.5648,13.4828 17.5648,13.1495 19.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.855
    },
    fill: "#f27329",
    d: "M 29.5,12.5 C 29.2627,13.791 29.596,14.791 30.5,15.5C 30.5,16.5 30.5,17.5 30.5,18.5C 30.5,19.1667 30.5,19.8333 30.5,20.5C 28.8333,20.5 27.1667,20.5 25.5,20.5C 24.6314,18.283 24.298,15.9496 24.5,13.5C 26.2915,13.634 27.9582,13.3007 29.5,12.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.779
    },
    fill: "#f2672a",
    d: "M 13.5,13.5 C 13.5,14.1667 13.5,14.8333 13.5,15.5C 13.3284,16.4916 13.6618,17.1583 14.5,17.5C 14.5,18.1667 14.5,18.8333 14.5,19.5C 12.5,19.5 10.5,19.5 8.5,19.5C 8.16667,17.5 7.83333,15.5 7.5,13.5C 9.5,13.5 11.5,13.5 13.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.85
    },
    fill: "#f26d29",
    d: "M 30.5,13.5 C 32.1667,13.5 33.8333,13.5 35.5,13.5C 35.8333,15.5 36.1667,17.5 36.5,19.5C 34.8333,19.5 33.1667,19.5 31.5,19.5C 31.5,18.8333 31.1667,18.5 30.5,18.5C 30.5,17.5 30.5,16.5 30.5,15.5C 30.5,14.8333 30.5,14.1667 30.5,13.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.852
    },
    fill: "#f26d29",
    d: "M 52.5,16.5 C 52.5172,18.5648 52.8505,20.5648 53.5,22.5C 50.9179,22.0254 48.9179,22.6921 47.5,24.5C 47.5,24.8333 47.5,25.1667 47.5,25.5C 45.8828,26.038 44.2161,26.3713 42.5,26.5C 41.962,24.8828 41.6287,23.2161 41.5,21.5C 43.0418,20.6993 44.7085,20.366 46.5,20.5C 47.404,19.791 47.7373,18.791 47.5,17.5C 49.2161,17.3713 50.8828,17.038 52.5,16.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.839
    },
    fill: "#f27329",
    d: "M 19.5,18.5 C 20.2679,20.7146 20.9346,23.0479 21.5,25.5C 18.8952,25.6206 16.8952,26.6206 15.5,28.5C 15.3284,29.4916 15.6618,30.1583 16.5,30.5C 14.6976,31.4582 12.6976,32.1249 10.5,32.5C 10.0074,30.1944 9.67412,27.861 9.5,25.5C 11.7354,25.7947 13.7354,25.4614 15.5,24.5C 15.6716,23.5084 15.3382,22.8417 14.5,22.5C 14.5,21.5 14.5,20.5 14.5,19.5C 16.4147,19.7845 18.0813,19.4511 19.5,18.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.877
    },
    fill: "#f26d29",
    d: "M 8.5,19.5 C 10.5,19.5 12.5,19.5 14.5,19.5C 14.5,20.5 14.5,21.5 14.5,22.5C 14.3284,23.4916 14.6618,24.1583 15.5,24.5C 13.7354,25.4614 11.7354,25.7947 9.5,25.5C 9.16667,23.5 8.83333,21.5 8.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.836
    },
    fill: "#f27329",
    d: "M 31.5,19.5 C 33.1667,19.5 34.8333,19.5 36.5,19.5C 36.8333,21.5 37.1667,23.5 37.5,25.5C 35.7839,25.6287 34.1172,25.962 32.5,26.5C 32.5,25.8333 32.1667,25.5 31.5,25.5C 31.5,24.5 31.5,23.5 31.5,22.5C 31.5,21.5 31.5,20.5 31.5,19.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.856
    },
    fill: "#f37928",
    d: "M 25.5,20.5 C 27.1667,20.5 28.8333,20.5 30.5,20.5C 30.3284,21.4916 30.6618,22.1583 31.5,22.5C 31.5,23.5 31.5,24.5 31.5,25.5C 31.5,25.8333 31.5,26.1667 31.5,26.5C 29.8828,27.038 28.2161,27.3713 26.5,27.5C 25.6314,25.283 25.298,22.9496 25.5,20.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "#f27329",
    d: "M 53.5,22.5 C 53.5172,24.5648 53.8505,26.5648 54.5,28.5C 51.9899,28.0535 49.9899,28.7202 48.5,30.5C 48.5,30.8333 48.5,31.1667 48.5,31.5C 46.7839,31.6287 45.1172,31.962 43.5,32.5C 42.6586,30.6208 42.3253,28.6208 42.5,26.5C 44.2161,26.3713 45.8828,26.038 47.5,25.5C 48.5069,27.4765 48.5069,27.1432 47.5,24.5C 48.9179,22.6921 50.9179,22.0254 53.5,22.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.863
    },
    fill: "#f37928",
    d: "M 21.5,25.5 C 21.298,27.9496 21.6314,30.283 22.5,32.5C 20.5,32.5 18.5,32.5 16.5,32.5C 16.5,33.5 16.5,34.5 16.5,35.5C 16.5,36.1667 16.5,36.8333 16.5,37.5C 14.8333,37.5 13.1667,37.5 11.5,37.5C 10.962,35.8828 10.6287,34.2161 10.5,32.5C 12.6976,32.1249 14.6976,31.4582 16.5,30.5C 16.6716,29.5084 16.3382,28.8417 15.5,28.5C 16.8952,26.6206 18.8952,25.6206 21.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.856
    },
    fill: "#f37928",
    d: "M 37.5,25.5 C 37.5172,27.5648 37.8505,29.5648 38.5,31.5C 36.8828,32.038 35.2161,32.3713 33.5,32.5C 33.5,31.8333 33.1667,31.5 32.5,31.5C 32.5,30.5 32.5,29.5 32.5,28.5C 32.5,27.8333 32.5,27.1667 32.5,26.5C 34.1172,25.962 35.7839,25.6287 37.5,25.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.861
    },
    fill: "#f37f27",
    d: "M 31.5,26.5 C 31.3284,27.4916 31.6618,28.1583 32.5,28.5C 32.5,29.5 32.5,30.5 32.5,31.5C 32.5,32.5 32.5,33.5 32.5,34.5C 30.8828,35.038 29.2161,35.3713 27.5,35.5C 26.9084,32.8728 26.5751,30.2062 26.5,27.5C 28.2161,27.3713 29.8828,27.038 31.5,26.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.868
    },
    fill: "#f37928",
    d: "M 54.5,28.5 C 54.5,30.1667 54.5,31.8333 54.5,33.5C 52.4687,33.9724 50.8021,34.9724 49.5,36.5C 47.9582,37.3007 46.2915,37.634 44.5,37.5C 43.5489,36.0813 43.2155,34.4147 43.5,32.5C 45.1172,31.962 46.7839,31.6287 48.5,31.5C 49.5069,33.4765 49.5069,33.1432 48.5,30.5C 49.9899,28.7202 51.9899,28.0535 54.5,28.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.838
    },
    fill: "#f38027",
    d: "M 38.5,31.5 C 38.6741,33.861 39.0074,36.1944 39.5,38.5C 37.9582,39.3007 36.2915,39.634 34.5,39.5C 34.5,38.8333 34.1667,38.5 33.5,38.5C 33.5,37.5 33.5,36.5 33.5,35.5C 33.5,34.5 33.5,33.5 33.5,32.5C 35.2161,32.3713 36.8828,32.038 38.5,31.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.841
    },
    fill: "#f37f27",
    d: "M 22.5,32.5 C 22.448,34.9029 22.7814,37.2362 23.5,39.5C 21.1016,39.2594 19.1016,39.9261 17.5,41.5C 17.5,42.1667 17.5,42.8333 17.5,43.5C 15.9724,44.3092 14.3057,44.9759 12.5,45.5C 11.9084,42.8728 11.5751,40.2062 11.5,37.5C 13.1667,37.5 14.8333,37.5 16.5,37.5C 17.8333,36.8333 17.8333,36.1667 16.5,35.5C 16.5,34.5 16.5,33.5 16.5,32.5C 18.5,32.5 20.5,32.5 22.5,32.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.833
    },
    fill: "#f37f27",
    d: "M 54.5,33.5 C 55.2679,35.7146 55.9346,38.0479 56.5,40.5C 53.784,40.3862 51.784,41.3862 50.5,43.5C 48.5853,43.2155 46.9187,43.5489 45.5,44.5C 44.5318,42.3926 44.1984,40.0593 44.5,37.5C 46.2915,37.634 47.9582,37.3007 49.5,36.5C 50.8021,34.9724 52.4687,33.9724 54.5,33.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.86
    },
    fill: "#f48627",
    d: "M 32.5,34.5 C 32.5,35.1667 32.8333,35.5 33.5,35.5C 33.5,36.5 33.5,37.5 33.5,38.5C 33.5,39.5 33.5,40.5 33.5,41.5C 32.0813,42.4511 30.4147,42.7845 28.5,42.5C 28.0074,40.1944 27.6741,37.861 27.5,35.5C 29.2161,35.3713 30.8828,35.038 32.5,34.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#f48627",
    d: "M 39.5,38.5 C 39.6741,40.861 40.0074,43.1944 40.5,45.5C 38.7839,45.6287 37.1172,45.962 35.5,46.5C 35.6716,45.5084 35.3382,44.8417 34.5,44.5C 34.5,43.5 34.5,42.5 34.5,41.5C 34.5,40.8333 34.5,40.1667 34.5,39.5C 36.2915,39.634 37.9582,39.3007 39.5,38.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.849
    },
    fill: "#f48627",
    d: "M 23.5,39.5 C 23.448,41.9029 23.7814,44.2362 24.5,46.5C 21.9899,46.0535 19.9899,46.7202 18.5,48.5C 18.5,49.1667 18.5,49.8333 18.5,50.5C 16.7839,50.6287 15.1172,50.962 13.5,51.5C 13.1667,49.5 12.8333,47.5 12.5,45.5C 14.3057,44.9759 15.9724,44.3092 17.5,43.5C 18.8333,42.8333 18.8333,42.1667 17.5,41.5C 19.1016,39.9261 21.1016,39.2594 23.5,39.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.848
    },
    fill: "#f48627",
    d: "M 56.5,40.5 C 56.5,42.5 56.5,44.5 56.5,46.5C 54.1523,46.5923 52.4856,47.5923 51.5,49.5C 49.5853,49.2155 47.9187,49.5489 46.5,50.5C 45.5386,48.7354 45.2053,46.7354 45.5,44.5C 46.9187,43.5489 48.5853,43.2155 50.5,43.5C 51.784,41.3862 53.784,40.3862 56.5,40.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.837
    },
    fill: "#f48c26",
    d: "M 33.5,41.5 C 33.8333,41.5 34.1667,41.5 34.5,41.5C 34.5,42.5 34.5,43.5 34.5,44.5C 34.5,45.8333 34.5,47.1667 34.5,48.5C 32.7839,48.6287 31.1172,48.962 29.5,49.5C 29.3259,47.139 28.9926,44.8056 28.5,42.5C 30.4147,42.7845 32.0813,42.4511 33.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.828
    },
    fill: "#f48c26",
    d: "M 40.5,45.5 C 40.8333,47.5 41.1667,49.5 41.5,51.5C 39.7839,51.6287 38.1172,51.962 36.5,52.5C 36.5,51.8333 36.1667,51.5 35.5,51.5C 35.5,50.5 35.5,49.5 35.5,48.5C 35.5,47.8333 35.5,47.1667 35.5,46.5C 37.1172,45.962 38.7839,45.6287 40.5,45.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#f48c26",
    d: "M 24.5,46.5 C 24.5172,48.5648 24.8505,50.5648 25.5,52.5C 23.2143,52.595 21.2143,53.2616 19.5,54.5C 19.5,55.1667 19.5,55.8333 19.5,56.5C 17.7085,56.366 16.0418,56.6993 14.5,57.5C 13.8505,55.5648 13.5172,53.5648 13.5,51.5C 15.1172,50.962 16.7839,50.6287 18.5,50.5C 19.8333,49.8333 19.8333,49.1667 18.5,48.5C 19.9899,46.7202 21.9899,46.0535 24.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.85
    },
    fill: "#f48c26",
    d: "M 56.5,46.5 C 57.4614,48.2646 57.7947,50.2646 57.5,52.5C 55.8333,52.5 54.1667,52.5 52.5,52.5C 52.7373,51.209 52.404,50.209 51.5,49.5C 52.4856,47.5923 54.1523,46.5923 56.5,46.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.843
    },
    fill: "#f49226",
    d: "M 34.5,48.5 C 34.8333,48.5 35.1667,48.5 35.5,48.5C 35.5,49.5 35.5,50.5 35.5,51.5C 35.5563,54.517 35.8897,54.8503 36.5,52.5C 38.1172,51.962 39.7839,51.6287 41.5,51.5C 41.6741,53.861 42.0074,56.1944 42.5,58.5C 40.8333,58.5 39.1667,58.5 37.5,58.5C 37.5,57.8333 37.1667,57.5 36.5,57.5C 36.6309,56.6236 36.2975,55.9569 35.5,55.5C 33.9291,56.3094 32.2624,56.6427 30.5,56.5C 30.3259,54.139 29.9926,51.8056 29.5,49.5C 31.1172,48.962 32.7839,48.6287 34.5,48.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.866
    },
    fill: "#f48c26",
    d: "M 51.5,49.5 C 51.2627,50.791 51.596,51.791 52.5,52.5C 51.1048,54.3794 49.1048,55.3794 46.5,55.5C 46.5,53.8333 46.5,52.1667 46.5,50.5C 47.9187,49.5489 49.5853,49.2155 51.5,49.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.846
    },
    fill: "#f49226",
    d: "M 25.5,52.5 C 25.448,54.9029 25.7814,57.2362 26.5,59.5C 24.1016,59.2594 22.1016,59.9261 20.5,61.5C 20.5,61.8333 20.5,62.1667 20.5,62.5C 18.8828,63.038 17.2161,63.3713 15.5,63.5C 14.8505,61.5648 14.5172,59.5648 14.5,57.5C 16.0418,56.6993 17.7085,56.366 19.5,56.5C 20.8333,55.8333 20.8333,55.1667 19.5,54.5C 21.2143,53.2616 23.2143,52.595 25.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.825
    },
    fill: "#f49226",
    d: "M 52.5,52.5 C 54.1667,52.5 55.8333,52.5 57.5,52.5C 58.4614,54.2646 58.7947,56.2646 58.5,58.5C 56.7085,58.366 55.0418,58.6993 53.5,59.5C 51.6264,60.2852 49.6264,60.9518 47.5,61.5C 47.4828,59.4352 47.1495,57.4352 46.5,55.5C 49.1048,55.3794 51.1048,54.3794 52.5,52.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.816
    },
    fill: "#f59726",
    d: "M 36.5,57.5 C 36.5,58.1667 36.5,58.8333 36.5,59.5C 34.8333,59.5 33.1667,59.5 31.5,59.5C 30.8902,58.609 30.5569,57.609 30.5,56.5C 32.2624,56.6427 33.9291,56.3094 35.5,55.5C 36.2975,55.9569 36.6309,56.6236 36.5,57.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#f59726",
    d: "M 37.5,58.5 C 39.1667,58.5 40.8333,58.5 42.5,58.5C 42.5,59.5 42.5,60.5 42.5,61.5C 40.5248,61.8222 38.8582,61.8222 37.5,61.5C 37.5,60.5 37.5,59.5 37.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.802
    },
    fill: "#f59726",
    d: "M 58.5,58.5 C 59.1098,59.391 59.4431,60.391 59.5,61.5C 57.5853,61.2155 55.9187,61.5489 54.5,62.5C 53.8333,62.5 53.5,62.8333 53.5,63.5C 51.8333,63.5 50.1667,63.5 48.5,63.5C 47.6618,63.1583 47.3284,62.4916 47.5,61.5C 49.6264,60.9518 51.6264,60.2852 53.5,59.5C 55.0418,58.6993 56.7085,58.366 58.5,58.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.878
    },
    fill: "#f59726",
    d: "M 26.5,59.5 C 26.5,60.5 26.5,61.5 26.5,62.5C 24.8828,63.038 23.2161,63.3713 21.5,63.5C 21.6716,62.5084 21.3382,61.8417 20.5,61.5C 22.1016,59.9261 24.1016,59.2594 26.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.829
    },
    fill: "#f59a25",
    d: "M 31.5,59.5 C 33.1667,59.5 34.8333,59.5 36.5,59.5C 36.3284,60.4916 36.6618,61.1583 37.5,61.5C 38.8582,61.8222 40.5248,61.8222 42.5,61.5C 43.4345,62.5676 43.7678,63.901 43.5,65.5C 41.8333,65.5 40.1667,65.5 38.5,65.5C 38.5,64.8333 38.1667,64.5 37.5,64.5C 35.6907,63.7093 33.6907,63.7093 31.5,64.5C 31.5,62.8333 31.5,61.1667 31.5,59.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.919
    },
    fill: "#f59a25",
    d: "M 59.5,61.5 C 59.5,62.8333 59.5,64.1667 59.5,65.5C 57.8333,65.5 56.1667,65.5 54.5,65.5C 54.5,64.5 54.5,63.5 54.5,62.5C 55.9187,61.5489 57.5853,61.2155 59.5,61.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.837
    },
    fill: "#f59726",
    d: "M 20.5,62.5 C 20.5,63.1667 20.8333,63.5 21.5,63.5C 20.3933,65.9689 18.3933,66.9689 15.5,66.5C 15.5,65.5 15.5,64.5 15.5,63.5C 17.2161,63.3713 18.8828,63.038 20.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.838
    },
    fill: "#f59a25",
    d: "M 26.5,62.5 C 27.2341,63.7079 27.5674,65.0413 27.5,66.5C 25.9582,67.3007 24.2915,67.634 22.5,67.5C 21.6618,67.8417 21.3284,68.5084 21.5,69.5C 19.8828,70.038 18.2161,70.3713 16.5,70.5C 16.1667,69.1667 15.8333,67.8333 15.5,66.5C 18.3933,66.9689 20.3933,65.9689 21.5,63.5C 23.2161,63.3713 24.8828,63.038 26.5,62.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.852
    },
    fill: "#f59f25",
    d: "M 37.5,64.5 C 37.6219,68.8383 37.9553,69.1716 38.5,65.5C 40.1667,65.5 41.8333,65.5 43.5,65.5C 43.8333,67.5 44.1667,69.5 44.5,71.5C 42.7085,71.366 41.0418,71.6993 39.5,72.5C 39.6716,71.5084 39.3382,70.8417 38.5,70.5C 36.5,70.5 34.5,70.5 32.5,70.5C 32.6747,68.3792 32.3414,66.3792 31.5,64.5C 33.6907,63.7093 35.6907,63.7093 37.5,64.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.894
    },
    fill: "#f59a25",
    d: "M 48.5,63.5 C 50.1667,63.5 51.8333,63.5 53.5,63.5C 53.3284,64.4916 53.6618,65.1583 54.5,65.5C 52.8984,67.0739 50.8984,67.7406 48.5,67.5C 48.5,66.1667 48.5,64.8333 48.5,63.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.831
    },
    fill: "#f59f25",
    d: "M 54.5,65.5 C 56.1667,65.5 57.8333,65.5 59.5,65.5C 60.4511,66.9187 60.7845,68.5853 60.5,70.5C 58.7839,70.6287 57.1172,70.962 55.5,71.5C 54.9553,67.8284 54.6219,68.1617 54.5,72.5C 52.8333,72.5 51.1667,72.5 49.5,72.5C 48.962,70.8828 48.6287,69.2161 48.5,67.5C 50.8984,67.7406 52.8984,67.0739 54.5,65.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.841
    },
    fill: "#f59f25",
    d: "M 27.5,66.5 C 27.6741,68.861 28.0074,71.1944 28.5,73.5C 26.5853,73.2155 24.9187,73.5489 23.5,74.5C 22.8333,74.5 22.5,74.8333 22.5,75.5C 20.7839,75.6287 19.1172,75.962 17.5,76.5C 16.8505,74.5648 16.5172,72.5648 16.5,70.5C 18.2161,70.3713 19.8828,70.038 21.5,69.5C 22.4202,70.0674 22.7535,69.4008 22.5,67.5C 24.2915,67.634 25.9582,67.3007 27.5,66.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.836
    },
    fill: "#f5a524",
    d: "M 32.5,70.5 C 34.5,70.5 36.5,70.5 38.5,70.5C 38.3433,71.8734 38.51,73.2068 39,74.5C 39.4643,73.9056 39.631,73.2389 39.5,72.5C 41.0418,71.6993 42.7085,71.366 44.5,71.5C 44.9926,73.8056 45.3259,76.139 45.5,78.5C 43.8333,78.5 42.1667,78.5 40.5,78.5C 40.5,77.8333 40.1667,77.5 39.5,77.5C 37.7839,77.6287 36.1172,77.962 34.5,78.5C 33.7451,75.9471 33.0784,73.2804 32.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.84
    },
    fill: "#f5a524",
    d: "M 60.5,70.5 C 61.1495,72.4352 61.4828,74.4352 61.5,76.5C 59.7839,76.6287 58.1172,76.962 56.5,77.5C 55.8897,75.1497 55.5563,75.483 55.5,78.5C 53.8333,78.5 52.1667,78.5 50.5,78.5C 49.8505,76.5648 49.5172,74.5648 49.5,72.5C 51.1667,72.5 52.8333,72.5 54.5,72.5C 55.1667,72.5 55.5,72.1667 55.5,71.5C 57.1172,70.962 58.7839,70.6287 60.5,70.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.861
    },
    fill: "#f5a524",
    d: "M 28.5,73.5 C 28.8333,75.5 29.1667,77.5 29.5,79.5C 27.9582,80.3007 26.2915,80.634 24.5,80.5C 23.8333,80.5 23.5,80.8333 23.5,81.5C 21.9582,82.3007 20.2915,82.634 18.5,82.5C 17.8505,80.5648 17.5172,78.5648 17.5,76.5C 19.1172,75.962 20.7839,75.6287 22.5,75.5C 23.206,76.5573 23.5393,76.2239 23.5,74.5C 24.9187,73.5489 26.5853,73.2155 28.5,73.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.817
    },
    fill: "#f6ab24",
    d: "M 61.5,76.5 C 62.1495,78.4352 62.4828,80.4352 62.5,82.5C 60.8333,82.5 59.1667,82.5 57.5,82.5C 56.794,81.4427 56.4607,81.7761 56.5,83.5C 54.7085,83.366 53.0418,83.6993 51.5,84.5C 50.6586,82.6208 50.3253,80.6208 50.5,78.5C 52.1667,78.5 53.8333,78.5 55.5,78.5C 56.1667,78.5 56.5,78.1667 56.5,77.5C 58.1172,76.962 59.7839,76.6287 61.5,76.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.842
    },
    fill: "#f6ab24",
    d: "M 39.5,77.5 C 39.6219,81.8383 39.9553,82.1716 40.5,78.5C 42.1667,78.5 43.8333,78.5 45.5,78.5C 45.8333,80.5 46.1667,82.5 46.5,84.5C 44.8333,84.5 43.1667,84.5 41.5,84.5C 41.1667,83.1667 40.8333,83.1667 40.5,84.5C 38.5853,84.2155 36.9187,84.5489 35.5,85.5C 34.5318,83.3926 34.1984,81.0593 34.5,78.5C 36.1172,77.962 37.7839,77.6287 39.5,77.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.839
    },
    fill: "#f6ab24",
    d: "M 29.5,79.5 C 29.6741,81.861 30.0074,84.1944 30.5,86.5C 28.5853,86.2155 26.9187,86.5489 25.5,87.5C 25.1667,87.5 24.8333,87.5 24.5,87.5C 22.8828,88.038 21.2161,88.3713 19.5,88.5C 18.6586,86.6208 18.3253,84.6208 18.5,82.5C 20.2915,82.634 21.9582,82.3007 23.5,81.5C 24.1103,83.8503 24.4437,83.517 24.5,80.5C 26.2915,80.634 27.9582,80.3007 29.5,79.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.848
    },
    fill: "#f6b223",
    d: "M 57.5,82.5 C 59.1667,82.5 60.8333,82.5 62.5,82.5C 63.0916,85.1272 63.4249,87.7938 63.5,90.5C 61.8333,90.5 60.1667,90.5 58.5,90.5C 57.9553,86.8284 57.6219,87.1617 57.5,91.5C 52.5049,91.8752 50.5049,89.5418 51.5,84.5C 53.0418,83.6993 54.7085,83.366 56.5,83.5C 57.1103,85.8503 57.4437,85.517 57.5,82.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.858
    },
    fill: "#f6b223",
    d: "M 40.5,84.5 C 40.8333,88.5 41.1667,88.5 41.5,84.5C 43.1667,84.5 44.8333,84.5 46.5,84.5C 47.0916,87.1272 47.4249,89.7938 47.5,92.5C 46.0695,92.4208 44.7362,92.7542 43.5,93.5C 42.224,88.3183 41.5573,88.3183 41.5,93.5C 39.8561,93.2865 38.3561,93.6198 37,94.5C 35.8512,91.6074 35.3512,88.6074 35.5,85.5C 36.9187,84.5489 38.5853,84.2155 40.5,84.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.856
    },
    fill: "#f6b223",
    d: "M 30.5,86.5 C 31.1587,89.4552 31.4921,92.4552 31.5,95.5C 29.2341,95.8588 27.4007,95.1922 26,93.5C 25.5172,94.448 25.3505,95.448 25.5,96.5C 23.8333,96.5 22.1667,96.5 20.5,96.5C 19.9084,93.8728 19.5751,91.2062 19.5,88.5C 21.2161,88.3713 22.8828,88.038 24.5,87.5C 24.8333,90.1667 25.1667,90.1667 25.5,87.5C 26.9187,86.5489 28.5853,86.2155 30.5,86.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.967
    },
    fill: "#f7be22",
    d: "M 116.5,94.5 C 101.135,96.6473 85.8021,98.9806 70.5,101.5C 69.7347,98.9039 69.4013,96.2372 69.5,93.5C 84.8333,91.5 100.167,89.5 115.5,87.5C 115.448,89.9029 115.781,92.2362 116.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.875
    },
    fill: "#f7c322",
    d: "M 116.5,94.5 C 116.5,95.8333 116.5,97.1667 116.5,98.5C 101.442,100.51 86.4424,102.843 71.5,105.5C 70.5713,104.311 70.238,102.978 70.5,101.5C 85.8021,98.9806 101.135,96.6473 116.5,94.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.922
    },
    fill: "#f7be22",
    d: "M 65.5,102.5 C 61.8455,102.942 58.1788,103.276 54.5,103.5C 53.6314,101.283 53.298,98.9496 53.5,96.5C 57.0723,96.0624 60.5723,95.3958 64,94.5C 64.8215,97.1168 65.3215,99.7835 65.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.916
    },
    fill: "#f7be22",
    d: "M 49.5,104.5 C 45.8333,105.167 42.1667,105.833 38.5,106.5C 37.7347,103.904 37.4013,101.237 37.5,98.5C 41.1788,98.2756 44.8455,97.9422 48.5,97.5C 48.9926,99.8056 49.3259,102.139 49.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.926
    },
    fill: "#f7be22",
    d: "M 33.5,107.5 C 29.8212,107.724 26.1545,108.058 22.5,108.5C 21.4249,106.144 21.4249,103.811 22.5,101.5C 25.5,100.833 28.5,100.167 31.5,99.5C 33.0538,101.933 33.7204,104.6 33.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.854
    },
    fill: "#f7c322",
    d: "M 65.5,102.5 C 65.5,103.833 65.5,105.167 65.5,106.5C 61.8455,106.942 58.1788,107.276 54.5,107.5C 54.5,106.167 54.5,104.833 54.5,103.5C 58.1788,103.276 61.8455,102.942 65.5,102.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.903
    },
    fill: "#f8cc21",
    d: "M 118.5,107.5 C 103.268,110.26 87.935,112.594 72.5,114.5C 71.6993,112.958 71.366,111.292 71.5,109.5C 85.6896,107.735 99.8563,105.735 114,103.5C 117.263,102.932 118.763,104.266 118.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.818
    },
    fill: "#f7c322",
    d: "M 49.5,104.5 C 49.33,105.822 49.6634,106.989 50.5,108C 46.5602,109.156 42.5602,109.99 38.5,110.5C 38.5,109.167 38.5,107.833 38.5,106.5C 42.1667,105.833 45.8333,105.167 49.5,104.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.819
    },
    fill: "#f7c322",
    d: "M 33.5,107.5 C 33.5394,108.583 33.8728,109.583 34.5,110.5C 30.5736,111.632 26.5736,112.299 22.5,112.5C 22.5,111.167 22.5,109.833 22.5,108.5C 26.1545,108.058 29.8212,107.724 33.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.917
    },
    fill: "#f8d120",
    d: "M 118.5,107.5 C 118.674,109.861 119.007,112.194 119.5,114.5C 104.619,116.507 89.7855,118.84 75,121.5C 72.8659,119.713 72.0325,117.38 72.5,114.5C 87.935,112.594 103.268,110.26 118.5,107.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.85
    },
    fill: "#f8cc21",
    d: "M 67.5,115.5 C 63.8333,116.167 60.1667,116.833 56.5,117.5C 55.962,115.883 55.6287,114.216 55.5,112.5C 58.876,112.048 62.2094,111.382 65.5,110.5C 67.2174,111.668 67.8841,113.335 67.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.842
    },
    fill: "#f8cc21",
    d: "M 51.5,118.5 C 47.8212,118.724 44.1545,119.058 40.5,119.5C 40.5792,118.07 40.2458,116.736 39.5,115.5C 43.3926,114.185 47.3926,113.518 51.5,113.5C 51.5,115.167 51.5,116.833 51.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.844
    },
    fill: "#f8cc21",
    d: "M 35.5,120.5 C 31.8068,121.06 28.1402,121.727 24.5,122.5C 23.9478,120.669 23.9478,119.003 24.5,117.5C 28.1309,116.648 31.7976,115.981 35.5,115.5C 35.5,117.167 35.5,118.833 35.5,120.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.856
    },
    fill: "#f8d120",
    d: "M 67.5,115.5 C 67.9926,117.806 68.3259,120.139 68.5,122.5C 64.7624,123.079 61.0957,123.079 57.5,122.5C 56.6906,120.929 56.3573,119.262 56.5,117.5C 60.1667,116.833 63.8333,116.167 67.5,115.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.874
    },
    fill: "#f8d120",
    d: "M 51.5,118.5 C 52.3414,120.379 52.6747,122.379 52.5,124.5C 48.9002,124.794 45.4002,125.46 42,126.5C 40.7978,124.323 40.2978,121.989 40.5,119.5C 44.1545,119.058 47.8212,118.724 51.5,118.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.89
    },
    fill: "#f8d120",
    d: "M 35.5,120.5 C 36.2186,122.764 36.552,125.097 36.5,127.5C 32.8333,127.5 29.1667,127.5 25.5,127.5C 24.962,125.883 24.6287,124.216 24.5,122.5C 28.1402,121.727 31.8068,121.06 35.5,120.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLokiIcon);
export default __webpack_public_path__ + "static/media/LokiIcon.ff0e30626c0ca6d2fc9e0fb284dd6cac.svg";
export { ForwardRef as ReactComponent };